<div class="cartHeader">
	{#if $$slots.left}
		<slot name="left" />
	{/if}
	{#if $$slots.right}
		<slot name="right" />
	{/if}
</div>
